import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import getColour from '@lendi-ui/commons/colours';
import Visibility from '@lendi-ui/icon/Visibility';
import VisibilityOff from '@lendi-ui/icon/VisibilityOff';
import Tabs from '@lendi-ui/tabs';

import { Body } from '@funnels/ui-components';

import { Container, FullWidthTab } from './index.style';

export interface VisibilityFiltersProps {
  activeTabIndex: number;
  visibleCount: number;
  hiddenCount: number;
  onChange: (index: number) => void;
}

const COLOR = getColour('interaction', 'disabled');
const LIST = [
  { icon: Visibility, text: (props: VisibilityFiltersProps) => `Visible (${props.visibleCount || 0})` },
  { icon: VisibilityOff, text: (props: VisibilityFiltersProps) => `Hidden (${props.hiddenCount || 0})` },
];

// TODO: UIS team will consolidate this issue in the future.
function getColor(isActive: boolean, themeName: string) {
  // https://lendi-aus.slack.com/archives/CAN0C86PL/p1647825099181159
  const ACTIVE_COLOR = themeName === 'lendi' ? getColour('secondary', 500) : getColour('interaction', 'main');
  return isActive ? ACTIVE_COLOR : COLOR;
}

function VisibilityFilters(props: VisibilityFiltersProps) {
  function handleTabChange(tabIndex: number) {
    props.onChange(tabIndex);
  }

  const theme = useContext(ThemeContext);

  return (
    <Container>
      <Tabs onChangeTabIndex={handleTabChange} activeTabIndex={props.activeTabIndex} isInverse>
        {LIST.map((tab, index) => {
          const color = getColor(props.activeTabIndex === index, theme.name);
          const Icon = tab.icon;

          return (
            <FullWidthTab key={index} icon={<Icon color={color} width="24px" height="24px" />}>
              <Body color={color}>{tab.text(props)}</Body>
            </FullWidthTab>
          );
        })}
      </Tabs>
    </Container>
  );
}

export default VisibilityFilters;
